import styled from 'styled-components';

export const MainWrapper = styled.div`
  padding-top: ${({ $light }) => ($light ? '40px' : '80px')};
  background: ${({ $dark }) => ($dark ? 'var(--lokalac-primary-2)' : null)};
`;
